import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import TestimonialsContent from "./TestimonialsContent";
export default class Testimonials extends Component {
  render() {
    let page = this.props.match.params.page;

    const urlParams = new URLSearchParams(window.location.search);

    return (
      <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <TestimonialsContent urlParams={urlParams} page={page} />
        <Footer />
      </div>
    );
  }
}
